import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
  MDBContainer,
  MDBCol,
  MDBRow,
  MDBBtn,
  MDBInput,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBInputGroup,
  MDBDatepicker,
  MDBSelect,
  MDBDatatable,
  MDBIcon, MDBTextArea,
  MDBPopconfirm, MDBPopconfirmMessage,
  MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter,
  MDBBadge, MDBTable, MDBTableHead, MDBTableBody

} from 'mdb-react-ui-kit';
import Helper from '../Helper';
import Navbar from './sub/navbar';
import JobDetail from './sub/JobDetail';
import moment from 'moment';
import Alert from './sub/dialog'
import Favoriteitem from './sub/favoriteitem'
import Billlist from './sub/billlist'
import { v4 as uuidv4 } from 'uuid';
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
  GridEditInputCell
} from '@mui/x-data-grid';

const Component = () => {
  const { state } = useLocation();
  let { name } = useParams();
  const error = useRef();
  const setError = (message) => error.current.showerror(message);
  const [selectionModel, setSelectionModel] = useState([]);
  const editjob = useRef();
  const [isFinalize, setIsFinalize] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [basicModal, setBasicModal] = useState(false);
  const toggleOpen = () => setBasicModal(!basicModal);
  const [transportJobList, setTransportJobList] = useState([]);
  const [selectedrow, setSelectedRow] = useState(null);
  const [summarydata, setSummarydata] = useState({});
  const [transportAccount, setTransportAccount] = useState({});
  const [billlist, setBilllist] = useState({ bills: [] });
  const [billitem, setBillitem] = useState([]);
  const [selectpaidby, setselectpaidby] = useState(1);
  const [customers, setCustomers] = useState([]);
  const [selectCustomer, setSelectCustomer] = useState();
  const fetchCustomers = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getCustomers`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        setCustomers([{ text: '', value: 0 }, ...data.Customers]);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to fetch customers');
      }
    } catch (err) {
      setError('An error occurred while fetching customers.');
    }
  };

  const [paidbylist, setpaidbylist] = useState([
    { text: 'บริษัท', value: 1 },
    { text: 'เครดิต', value: 2 },
    { text: 'เงินสด', value: 3 }
  ]);

  const [resultData, setResultData] = useState({
    columns: [

      { label: "เลขที่เอกสาร", field: 'name', sort: false, flex: 1 },
      { label: "วันที่เอกสาร", field: 'jobdate', sort: false, width: 200, align: "center", headerAlign: "center" },
      { label: "วันครบกำหนด", field: 'duedate', sort: false, width: 200, align: "center", headerAlign: "center" },
      {
        label: "จำนวนเงินวางบิล", field: 'totalnetamount', sort: false, width: 300, align: "right", headerAlign: "right",
        valueFormatter: (params) => parseFloat(params).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      },
      {
        label: "WHT", field: 'totalwhtamount', sort: false, width: 200, align: "right", headerAlign: "right",
        valueFormatter: (params) => parseFloat(params).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      },
    ],
    rows: []
  });


  const unapprove = async () => {
  
  
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/revertTransportAccount_bill/${transportAccount.id}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${Helper.gettoken()}`,
            'Content-Type': 'application/json'
          }
        });
  
        if (response.ok) {
          transportAccount.statusid == 2
            setIsFinalize(false);
        } else {
          const data = await response.json();
          setError(data.message || 'Failed to fetch transport list');
        }
      } catch (err) {
        setError('An error occurred while fetching the transport list.');
      }
    }
  

    const approve = async (e) => {
        e.preventDefault();
    if (billlist.bills.length == 0) { setError("ไม่มีข้อมูล"); return; }
    if (!transportAccount.customerid) { setError("ไม่มีข้อมูลผู้ว่าจ้าง"); return; }
    setIsLoading(true);
    try {

      transportAccount.duedate = document.getElementById("duedate").value;
      transportAccount.billdate = document.getElementById("billdate").value;
      transportAccount.remark = document.getElementById("remark").value;
      transportAccount.summarydata = summarydata;
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/saveTransportAccount_bill`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ transportAccount, billlist, approve: true }),
      });
      const data = await response.json();
      if (response.ok) {
        setTransportAccount(data.transportAccount_bill);
        setBilllist({ bills: [...data.bills] });

        error.current.showmessage("บันทึกข้อมูลเรียบร้อยแล้ว")
      } else {

        setError(data.message);
      }
    } catch (err) {
      setError('An error occurred. Please try again later.');
    }
    finally {
      // Reset loading state
      setIsLoading(false);
    }
    }


  const saveData = async (e) => {
    e.preventDefault();
    if (billlist.bills.length == 0) { setError("ไม่มีข้อมูล"); return; }
    if (!transportAccount.customerid) { setError("ไม่มีข้อมูลผู้ว่าจ้าง"); return; }
    setIsLoading(true);
    try {

      transportAccount.duedate = document.getElementById("duedate").value;
      transportAccount.billdate = document.getElementById("billdate").value;
      transportAccount.remark = document.getElementById("remark").value;
      transportAccount.summarydata = summarydata;
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/saveTransportAccount_bill`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ transportAccount, billlist }),
      });
      const data = await response.json();
      if (response.ok) {
        setTransportAccount(data.transportAccount_bill);
        setBilllist({ bills: [...data.bills] });

        error.current.showmessage("บันทึกข้อมูลเรียบร้อยแล้ว")
      } else {

        setError(data.message);
      }
    } catch (err) {
      setError('An error occurred. Please try again later.');
    }
    finally {
      // Reset loading state
      setIsLoading(false);
    }

  }
  const navigate = useNavigate();

  const getTransportAccount_bill = async (transportname) => {

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getTransportAccount_bill/${transportname}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        if (!data.transportAccount) {
          setError('ไม่มีข้อมูลการขนส่ง');
          return;
        }

        setSummarydata({
          totalamount: data.transportAccount.totalamount,
          totalnetamount: data.transportAccount.totalnetamount,
          totalvatamount: data.transportAccount.totalvatamount,
          totalwhtamount: data.transportAccount.totalwhtamount,
          totalpaidamount: data.transportAccount.totalpaidamount
        });
        setTransportAccount(data.transportAccount);
        setBilllist({ bills: [...data.bills] });
        setSelectCustomer(data.transportAccount.customerid);

        setIsFinalize(data.transportAccount.statusid == 3 ? true : false);
        //setselectpaidby(data.transportAccount.paidbyid)
        // getBilllist(data.transportAccount.id);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to fetch transport list');
      }
    } catch (err) {
      setError('An error occurred while fetching the transport list.');
    }
  }



  const getTransportAccountList = async (customerid) => {


    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getTransportAccountListbycustomerid/${customerid}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        var filterlist = data.transportJobList.filter(e => e.transport_billid == null || e.transport_billid == transportAccount.id)
        setTransportJobList(filterlist);
        generateTree(filterlist);
        if (name && name != "") {
          setSelectionModel(billlist.bills.map(e => e.id));
        }
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to fetch transport list');
      }
    } catch (err) {
      setError('An error occurred while fetching the transport list.');
    }
  }

  useEffect(() => {
    // Get the token from sessionStorage


    if (!["accountant", "billing", "admin"].includes(Helper.getuserrole())) {
      navigate('/main');
      return;
    }
    name && getTransportAccount_bill(name);

    fetchCustomers();


  }, []);

  useEffect(() => {
    setSelectionModel([]);

    if (selectCustomer && selectCustomer > 0) {
      getTransportAccountList(selectCustomer);

    }
    else {
      setTransportJobList([]);
      generateTree([]);

    }


  }, [selectCustomer]);

  useEffect(() => {


    selectrow(selectionModel);


  }, [selectionModel]);

  const addduedate = (duration) => {
    var currentduedate = document.getElementById("billdate").value;
    currentduedate = moment(currentduedate, "DD/MM/YYYY").add(duration, "days");
    document.getElementById("duedate").value = currentduedate.format("DD/MM/YYYY");
  }

  const endEdit = () => {



  }
  const editRow = (row) => {

    setBasicModal(true);
    setSelectedRow({ row });

  }
  const deleteRow = (row) => {



  }
  const selectrow = (rows) => {


    var bills = transportJobList.filter(e => rows.includes(e.id))
    bills.forEach(bill => {
      const existingBill = billlist.bills.find(b => b.id === bill.id);
      if (existingBill) {
        bill.rowid = existingBill.rowid;
      }
    });
    setBilllist({ bills: [...bills] });
    updatesummary(bills);

  }

  const updatesummary = (bills) => {
    var summarydata = { totalamount: 0, totalwhtamount: 0, totalvatamount: 0, totalnetamount: 0, totalpaidamount: 0, totalnotpaidamount: 0 };

    bills.forEach(bill => {

      summarydata.totalamount += parseFloat(bill.totalamount ? bill.totalamount : 0);
      summarydata.totalwhtamount += parseFloat(bill.totalwhtamount ? bill.totalwhtamount : 0);
      summarydata.totalvatamount += parseFloat(bill.totalvatamount ? bill.totalvatamount : 0);
      summarydata.totalnetamount += parseFloat(bill.totalnetamount ? bill.totalnetamount : 0);
      summarydata.totalpaidamount += parseFloat(bill.totalpaidamount ? bill.totalpaidamount : 0);
      summarydata.totalnotpaidamount += parseFloat(bill.totalnotpaidamount ? bill.totalnotpaidamount : 0);
    });


    setSummarydata(summarydata);
  }

  const generateTree = (item) => {
    var main = item.map((row) => {
      return {
        ...row,
        jobdate: moment(row.jobdateobj).format("DD/MM/YYYY"),
        duedate: row.duedateobj ? moment(row.duedateobj).format("DD/MM/YYYY") : "",
        action: (
          <>

            <>   {row.statusid != 3 && <MDBBtn outline size='sm' floating className='call-btn' onClick={() => window.open('/TransportAccount/' + row.name, '_blank')}>
              <MDBIcon icon='pen' />
            </MDBBtn>}
            </>


          </>
        )

      }
    });



    var _resultData = {

      rows: main
    }

    _resultData.columns = [...resultData.columns];

    setResultData(_resultData);


  }


  return (<>
    <Navbar />
    <MDBContainer fluid className="my-3">
      <Alert ref={error} />

      <MDBRow className="justify-content-center">
        <MDBCol md="12">
          <MDBCard className="shadow-4 rounded-5">
            <MDBCardHeader>
              <MDBRow className='bg-body-tertiary d-flex align-items-center'>
                <MDBCol md='8'>
                  <h4>{ transportAccount.name?`ข้อมูลใบวางบิล (${transportAccount.name} - วันที่เอกสาร ${moment(transportAccount?.jobdateobj).format('DD/MM/YYYY  HH:mm')})`:"ลงข้อมูลใบวางบิล"}</h4>
                </MDBCol>
                <MDBCol md='2'>
                  <div className='d-flex flex-row-reverse me-3'>

                    {transportAccount.name && ["billing", "admin"].includes(Helper.getuserrole()) && <div className="d-grid gap-2 d-md-flex justify-content-md-end me-3">
                      <MDBBtn rounded size='lg' color='info' onClick={() => window.open(`/Print/Billlist/` + transportAccount.name, '_blank')} disabled={isLoading}>พิมพ์ใบแจ้งหนี้</MDBBtn>
                    </div>}
                  </div>
                </MDBCol>

                <MDBCol md='1'>

                  {!isFinalize && ["billing", "admin"].includes(Helper.getuserrole()) && <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <MDBBtn rounded size='lg' color='success' onClick={approve} disabled={isLoading}>อนุมัติ</MDBBtn>
                  </div>}

                  {isFinalize && ["admin"].includes(Helper.getuserrole()) && <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <MDBBtn rounded size='lg' color='danger' onClick={unapprove} disabled={isLoading}>ยกเลิกอนุมัติ</MDBBtn>
                  </div>}

                </MDBCol>
                <MDBCol md='1'>
                  {!isFinalize && <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <MDBBtn rounded size='lg' color='secondary' onClick={saveData} disabled={isLoading}>บันทึก</MDBBtn>
                  </div>}
                </MDBCol>
              </MDBRow>


            </MDBCardHeader>
            <MDBCardBody>
              <MDBRow className="mt-3">
                <MDBCol md="5">
                  <MDBInputGroup textBefore='ผู้ว่าจ้าง' className='mb-3 dropdown-group'>
                    <MDBSelect
                      disabled={name && name != ""}
                      search
                      data={customers}
                      displayValue={(row) => row.name}
                      label='เลือกผู้ว่าจ้าง'
                      value={selectCustomer}
                      onChange={(e) => {
                        if (e.value === 0) {
                          setSelectCustomer(0);
                          document.getElementById("tax").value = '';
                          return;
                        }
                        setSelectCustomer(e.value);
                        const selectedCustomer = customers.find(customer => customer.value === e.value);
                        if (selectedCustomer) {
                          transportAccount.customerid = selectedCustomer.value;
                          transportAccount.customername = selectedCustomer.text;
                          transportAccount.tax = selectedCustomer.tax;
                          document.getElementById("tax").value = selectedCustomer.tax || '';
                        }
                      }}
                    />

                    <span className='input-group-text'>เลขภาษี</span>
                    <input className='form-control' type='text' id="tax" readOnly />
                  </MDBInputGroup>
                </MDBCol>
                {/* <MDBCol md="2">

                  <MDBInputGroup textBefore='จ่าย' className='mb-3 dropdown-group'>
                    <MDBSelect
                      data={paidbylist}
                      value={selectpaidby}
                      onChange={(e) => {
                        setselectpaidby(e.value);
                      }}
                    />
                  </MDBInputGroup>

                </MDBCol> */}

                <MDBCol md="7">

                  <MDBInputGroup textBefore='วันวางบิล' className='mb-3 dropdown-group'>
                    <MDBDatepicker inputToggle inline id={"billdate"} inputLabel="วันวางบิล" onChange={(value) => transportAccount.billdate = value} value={transportAccount?.billdate ? transportAccount?.billdate : (transportAccount?.billdateobj ? moment(transportAccount?.billdateobj).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY'))} />
                    <span className='input-group-text'>วันครบกำหนด</span>
                    <MDBDatepicker inputToggle inline id={"duedate"} inputLabel="วันครบกำหนด" onChange={(value) => { transportAccount.duedate = value }} value={transportAccount?.duedate ? transportAccount?.duedate : (transportAccount?.duedateobj ? moment(transportAccount?.duedateobj).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY'))} />
                    <MDBBtn outline color='dark' onClick={() => addduedate(3)}>+3 วัน</MDBBtn>
                    <MDBBtn outline color='dark' onClick={() => addduedate(7)}>+7 วัน</MDBBtn>
                    <MDBBtn outline color='dark' onClick={() => addduedate(30)}>+30 วัน</MDBBtn>
                  </MDBInputGroup>

                </MDBCol>
                <MDBCol md="12">
                  <MDBTextArea
                    label="หมายเหตุ"
                    id={"remark"}
                    name="remark"
                    defaultValue={transportAccount.remark}
                    className="mb-3"
                    rows={2}
                  />
                </MDBCol>
                <MDBCol md="12">
                  <MDBInputGroup textBefore='สรุป' className='mb-3 '>
                    <span className='input-group-text'>มูลค่าไม่รวมภาษี {summarydata?.totalamount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} บาท</span>

                    <span className='input-group-text'>ภาษีมูลค่าเพิ่ม 7% {summarydata?.totalvatamount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>

                    <span className='input-group-text'>จำนวนเงินที่ถูกหัก ณ ที่จ่าย {summarydata?.totalwhtamount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} บาท</span>
                    <span className='input-group-text'>จำนวนเงินที่ชำระ  {summarydata?.totalpaidamount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} บาท</span>
                    <span className='input-group-text'><b>จำนวนเงินทั้งสิ้น  {summarydata?.totalnetamount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} บาท</b></span>
                  </MDBInputGroup>
                </MDBCol>

                {/* {billitem && billitem.length > 0 && billitem.filter(e => e.canaddtoall == 1).map((item, i) => (<Favoriteitem key={i} item={item} callback={addtoall} />))}
                 */}
              </MDBRow>
              <div className='d-flex align-items-center h-100 mb-2'>






                <DataGrid

                  rows={resultData.rows}
                  disableColumnMenu
                  keepNonExistentRowsSelected
                  columns={resultData.columns.map((col) => ({
                    ...col,
                    headerName: col.label,
                    field: col.field,
                    sortable: col.sort,
                  }))}

                  checkboxSelection

                  onRowSelectionModelChange={(newSelectionModel) => {
                    setSelectionModel(newSelectionModel);
                  }}
                  rowSelectionModel={selectionModel}
                />




              </div>
              {!isFinalize && <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                <MDBBtn rounded size='lg' color='secondary' onClick={saveData} disabled={isLoading}>บันทึก</MDBBtn>
              </div>}
            </MDBCardBody>

          </MDBCard>
        </MDBCol>
      </MDBRow>



    </MDBContainer>
  </>
  );
};

export default Component;
